import { useSelector } from "react-redux";
import { hasUserPermission } from "../companyUserAccess";

export default function usePermission() {
  const { accessType, companiesDB } = useSelector((state) => state.clientFunction);
  const user = accessType === "USER_ACCESS" ? companiesDB?.staffData || {} : companiesDB?.clientData || {};
  const permissions = user?.role?.permissions ?? user?.permissions ?? [];
  const can = (permission) => accessType === "CLIENT_ACCESS" ||
    (accessType === "USER_ACCESS" && hasUserPermission(user, permission));
  const canAll = (permissionList = []) => Array.isArray(permissionList) && permissionList.every(can);
  const canAny = (permissionList = []) => Array.isArray(permissionList) && permissionList.some(can);
  const getPermissions = () => permissions;
  return { user, permissions, can, canAll, canAny, getPermissions };
}
